import React from 'react';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FormError = ({ text }) => (
  <section className="text-center p-2 mb-2 rounded border border-red-600 bg-red-800">
    <p className="text-red-100 font-semibold">
      <FontAwesomeIcon icon={faBan} />
      <span className="ml-1">{text}</span>
    </p>
  </section>
);

export default FormError;
